import initialBillingState from "../billing.initialState";
import { reduxActions as BILLING } from "_constants/billing.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const backRemovals = {
  [BILLING.BACK_REMOVALS_STARTED]: (state) => ({
    ...state,
    backRemovals:{
      ...state.backRemovals,
      status: LOADING
    }
  }),

  [BILLING.BACK_REMOVALS_FAIL]: (state, { payload }) => ({
    ...state,
    backRemovals:{
      ...state.backRemovals,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [BILLING.BACK_REMOVALS_SUCCESS]: (state, { payload }) => ({
    ...state,
    backRemovals:{
      ...state.backRemovals,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),

  [BILLING.BACK_REMOVALS_RESET]: (state) => ({
    ...state,
    backRemovals: initialBillingState.backRemovals
  })
};

export default backRemovals;
